<template>
  <div class="record-main">
    <div class="user-info">
      <div>
        {{ recordList.list[0]?.studentName }} &nbsp;&nbsp; &nbsp;{{ recordList.list[0]?.sex || '---' }}
      </div>
      <div @click="onChangeUser">切换检查人<van-icon name="arrow" size="16px" /></div>
    </div>
    <div class="report-tip">
      点击下方绿色卡片，查看详细报告
    </div>
    <div class="record" v-if="pageType == 2">
      <div v-for="(item, index) in recordList.list" :key="index" class="record-item">
        <div @click="onShowMask(item)">{{ onFormatDate(item.recordDate) }}</div>
        <div @click='onGoQr(item)'><i class="van-icon van-icon-qr ewm"></i></div>
        <!-- <div @click='onShowMask(item)' v-if="pageType == 1">详情 <van-icon name="arrow" size="15px" /></div> -->
        <div @click='onShowMask(item)' v-if="pageType == 2">视力评估 <van-icon name="arrow" size="16px" /></div>
      </div>
    </div>
    <div class="record-new" v-if="pageType == 1">
      <!-- <div v-for="(item, index) in recordList.list" :key="index" class="record-item">
        <div @click="onShowMask(item)">{{ onFormatDate(item.recordDate) }}</div>
        <div @click='onGoQr(item)'><i class="van-icon van-icon-qr ewm"></i></div>
        <div @click='onShowMask(item)' v-if="pageType == 1">详情 <van-icon name="arrow" size="15px" /></div>
      </div> -->
      <div 
        v-for="(item, index) in recordList.list" 
        :key="index" 
        class="record-item" @click="onShowMask(item)"
      >
        <!-- 记录头部：日期和年龄信息 -->
        <div class="record-header">
          <div class="record-date">
            日期：{{ onFormatDate(item.recordDate) }}
          </div>
          <div class="record-age">
            {{ item.age }}岁
          </div>
          <!-- <div class="record-qr" @click="onGoQr(item)">
            <i class="van-icon van-icon-qr ewm"></i>
          </div> -->
        </div>
        
        <!-- 记录内容表格 -->
        <table class="record-table">
          <tbody>
            <tr>
              <td class="label">右</td>
              <td></td>
              <td class="label">左</td>
			  <td class="label-space"></td>
              <td class="label">右</td>
              <td></td>
              <td class="label">左</td>
            </tr>
            <!-- 球镜行 -->
            <tr>
              <td class="label-bold">{{ formatFixed2(item.avg_right_ball) }}</td>
              <td class="label">球镜</td>
              <td class="label-bold">{{ formatFixed2(item.avg_left_ball) }}</td>
			  <td class="label-space"></td>
              <td class="label-bold">{{ item.rightAxialLength }}</td>
              <td class="label">眼轴</td>
              <td class="label-bold">{{ item.leftAxialLength }}</td>
            </tr>
            
            <!-- 柱镜行 -->
            <tr>
              <td class="label-bold">{{ formatFixed2(item.avg_right_syl) }}</td>
              <td class="label">柱镜</td>
              <td class="label-bold">{{ formatFixed2(item.avg_left_syl) }}</td>
			  <td class="label-space"></td>
              <td class="label-bold">{{ formatFixedNoPlus(item.rightEyeCurvatureR1) }}</td>
              <td class="label big-font">K1</td>
              <td class="label-bold">{{ formatFixedNoPlus(item.leftEyeCurvatureR1) }}</td>
            </tr>
            
            <!-- 轴位行 -->
            <tr>
              <td class="label-bold">{{ formatVal(item.avg_right_axial) }}</td>
              <td class="label">轴位</td>
              <td class="label-bold">{{ formatVal(item.avg_left_axial) }}</td>
			  <td class="label-space"></td>
              <td class="label-bold">{{ formatFixedNoPlus(item.rightEyeCurvatureR2) }}</td>
              <td class="label">K2</td>
              <td class="label-bold">{{ formatFixedNoPlus(item.leftEyeCurvatureR2) }}</td>
            </tr>
            
            <!-- 裸视行 -->
            <tr>
              <td class="label-bold">{{ formatShili(item.rightNakedeyeVision) }}</td>
              <td class="label">裸视</td>
              <td class="label-bold">{{ formatShili(item.leftNakedeyeVision) }}</td>
			  <td class="label-space"></td>
              <td class="label-bold">{{ formatVal(item.rightAcd) }}</td>
              <td class="label">前房</td>
              <td class="label-bold">{{ formatVal(item.leftAcd) }}</td>
            </tr>
            
            <!-- 矫视行 -->
            <tr>
              <td class="label-bold">{{ formatShili(item.rightGlassesVision) }}</td>
              <td class="label">矫视</td>
              <td class="label-bold">{{ formatShili(item.leftGlassesVision) }}</td>
			  <td class="label-space"></td>
              <td class="label-bold">{{ formatVal(item.rightCrystal) }}</td>
              <td class="label">晶厚</td>
              <td class="label-bold">{{ formatVal(item.leftCrystal) }}</td>
            </tr>
			
          </tbody>
        </table>
        <div style="color:white;padding: 0.65em 10px 0 10px">
				<div class="label-bold" style="text-align: right; font-size: 1em;"> 
				{{item.screenType == 2? "院内:  ":"校园:  "}} {{item.schoolName}}</div>
		</div>
        <!-- 详情按钮 -->
        <!-- <div class="record-detail" @click="onShowMask(item)">
          详情 <van-icon name="arrow" size="15px" />
        </div> -->
      </div>
    </div>
    <div class="loading" v-if="showLoading"><van-loading type="spinner" />数据加载中...</div>
    <div v-if="showEwm" class="maskbox">
      <div class="mask" style="padding-bottom: 0.3rem;">
        <div class="maskclose" @click="showEwm = false">
          <img src="../../assets/img/close.png" />
        </div>
        <div class="codetip">{{ studentName || '' }}</div>
        <div id="qrCode" class="ewmcode" ref="qrCodeDiv"></div>
        <div class="codetip">
          <div>检查时，请出示此二维码。</div>
          <div style="text-align:left;">离院后如需咨询医生，请关闭此页，点击公众号左下角“在线咨询”，按提示选择医生咨询</div>
        </div>
      </div>
    </div>
    <div v-if="showXieyi" class="maskbox-one">
      <div class="mask">
        <div class='tip-one'>
          <div class="mask-title">用户协议及隐私政策</div>
          <div class="mask-content">为了更好的保障您的合法权益，请您阅读并同意以下协议</div>
          <div class="mask-xieyi">
            <span class="xieyi-href" @click="onGoXieyi">《用户协议及隐私政策》</span>
          </div>
          <div class="mask-btn-div">
            <div class="mask-btn" @click="onCancel">不同意</div>
            <div class="mask-btn ok" @click="onGoDetail">同意</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import { formatDate } from './js/record.js';
export default {
  name: 'uniapp-record',
  data() {
    return {
      hospitalId: '',
      openId: '',
      pageType: 1,  // 用于区分当前页面 1. 详情 2 视力评估
      user: '',
      userList: {},
      recordList: { list: '' },
      showEwm: false,
      studentName: '',
      isCheck: false,
      showLoading: true,
      studentIds: '',
      isOne: 0,
      showXieyi: false,
      nowItem: {},
    };
  },
  mounted() {
    document.title = '检查列表';
    this.openId = this.$route.query.openId || '';
	console.log("==="+ this.$route.query.hospitalId)
    this.hospitalId = this.$route.query.hospitalId || '';
    this.pageType = this.$route.query.pageType || 1;
    if (!this.openId || this.openId == 'undefined' ){
      this.showLoading = 0;
      return;
    }
    if (this.$route.query.uid && this.$route.query.studentIds) {
      this.onGetRecord(this.$route.query.uid, this.$route.query.studentIds);
    } else {
      this.onGetUserList();
    }
  },
  methods: {
    onFormatDate(date) { return formatDate(date); },
    async onGetUserList() {
      const auth = this.$createAuth(this.$md5);
      const _this = this;
      if (!this.openId) {
        this.showLoading = 0;
        return;
      }
      const result = await this.$http.get(this.$url.relatedStudents, {
        openId: this.openId,
        hospitalId: this.hospitalId,
        page: 1,
        pageSize: 30,
        auth: auth.code,
        time: auth.time
      });
      if (result.message === 'Error: Miss auth parameter.') {
        setTimeout(()=> {
          _this.showLoading = false;
          _this.isLoad = false;
          _this.onGetUserList();
        }, 500);
      } else {
		if(this.hospitalId && result.data.studentList.list.length < 1){
			return;
		}
        this.showLoading = 0;
        const userList = [...this.recordList.list, ...result.data.studentList.list]
        const record_select = localStorage.getItem('record_select');
        if (record_select) {
          this.user = JSON.parse(record_select);
          this.onGetRecord(this.user.uid, this.user.studentIds); 
        }else{
          this.user = userList[0];
          this.onGetRecord(userList[0].uid, userList[0].studentIds);
        }
      }
    },

    /**
     * 获取记录
    */
    async onGetRecord(uid, studentIds) {
      const auth = this.$createAuth(this.$md5);
      const result = await this.$http.get(this.$url.checkList, {
        openId: this.openId,
        studentId: uid,
        studentIds: studentIds,
        auth: auth.code,
        time: auth.time
      });
      const _this = this;
      if (result.message === 'Error: Miss auth parameter.') {
        setTimeout(()=> {
          _this.showLoading = 0; _this.onGetRecord(sid);
        }, 500);
      } else {
        this.showLoading = 0;
        this.recordList.list = result.data.chekList;
        let list = result.data.chekList;
        if (list.length == 1) {
          let item = list[0]
          if (item.screenType == 0) {
            let hospitalId = item.hospitalId;
            if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
            let sid = item.uid;
            let activityId = item.activityId
            if (typeof (activityId) == "undefined") activityId = ''
            if (item.checkType === 1 && item.clazzId && activityId) {
              this.$http.post(this.$url.updateCheck, {
                auth: auth.code,
                time: auth.time,
                activityId: item.activityId,
                hospitalId: item.hospitalId,
                clazzId: item.clazzId,
                studentId: item.studentId,
              }, { headers: { "content-type": "application/json" } });
            }
          }
        }
      }
    },
    onChangeUser() {
      this.$router.push(`/uniapp/user?openId=${this.openId}&hospitalId=${this.hospitalId}&pageType=${this.pageType}`);
    },
    onGoQr(item) {
      let _this = this;
      let sid = item.uid;
      this.showEwm = true;
      this.studentName = item?.studentName;
      let url = item.codeUrl;
      setTimeout(function () {
        new QRCode(_this.$refs.qrCodeDiv, {
          text: url,
          width: 135,
          height: 135,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      }, 500)

    },
    /**
     * 跳转详情页面
    */
    async goDetail(item) {
      let auth = this.$createAuth(this.$md5);
      let hospitalId = item.hospitalId;
      if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
      let sid = item.uid;
      let activityId = item.activityId == null ? '' : item.activityId
      if (typeof (activityId) == "undefined") activityId = ''
      if (item.checkType === 1 && item.clazzId && activityId) {
        this.$http.post(this.$url.updateCheck, {
          auth: auth.code,
          time: auth.time,
          activityId: item.activityId,
          hospitalId: item.hospitalId,
          clazzId: item.clazzId,
          studentId: item.studentId,
        }, { headers: { "content-type": "application/json" } });
      }
      if (this.pageType == 1) this.$router.push(`/uniapp/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item.studentId}`);
      if (this.pageType == 2) this.$router.push(`/uniapp/analysis?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item.studentId}`);
    },
    checkXieyi() {
      this.isCheck = !this.isCheck;
    },
    checkXieyiOne() {
      this.$router.push(`/detail?sid=${this.$route.query.sid}&screenType=${this.$route.query.screenType}&activityId=${this.$route.query.activityId}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&tuid=${this.$route.query.tuid}`);
    },
    onGoXieyi() {
      this.$router.push(`/xieyi`);
    },
    onCancel() {
      this.showXieyi = false;
    },
    onShowMask(item) {
      this.showXieyi = true;
      this.nowItem = item;
    },
    onGoDetail() {
      if (this.isOne) {
        this.checkXieyiOne();
      } else {
        this.goDetail(this.nowItem);
      }
    },
    formatVal(value) {
      return value == null ? '' : value;
    },
    formatFixed2(value) {
      if (value == '0') value = '0.00'
      value = (value == null || value == 'null' || value == '') ? '' : (value > 0 ? '+' + parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2));
      return value;
    },
	formatFixedNoPlus(value) {
	  if (value == '0') value = '0.00'
	  value = (value == null || value == 'null' || value == '') ? '' : (value > 0 ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2));
	  return value;
	},
    formatShili(value) {
      let temp = value;
      temp = '5.10'
      if (value != null && value != 'null' && value != '') {
        value += " ";
        temp = value.substring(value.indexOf(".") + 1);
        temp = temp.replace(" ", '');
        if (temp.length > 2) {
          temp = parseFloat(value).toFixed(2);
        } else {
          if (temp.length < 2) {
            temp = parseFloat(value).toFixed(1);
          } else {
            temp = value;
          }
        }
      } else {
        temp = ''
      }
      if (temp) {
        let tempArr = temp.split('.');
        if (tempArr[1].indexOf('0') == 1) {
          tempArr[1] = tempArr[1].replace(0, '')
        }
        temp = tempArr[0] + '.' + tempArr[1]
      }
      return temp.replace('.00', '.0');
    }
  },
 
};
</script>
<style scope lang="less">
.record-main {
  width: 100vw;
  height: 100vh;
  background-color: #f4f4f4 !important;
}
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}
.user-info {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 0.6rem);
  padding: 0.3rem;
  font-size: 0.37rem;
  color: #2d3f58;
  background: #fff;
  font-family: "Arial", "思源黑体", "等线","Segoe UI", "STSong", "Heiti SC", "Noto Sans SC", sans-serif;
  
}

 
.report-tip {
  padding: 0.2rem 0.2rem 0rem 0.2rem;
  font-size: 0.3rem;
  color: #666;
  background-color: #f4f4f4;
  text-align: center;
  margin-bottom: 0.05rem;
}

.record {
  margin-top: 0.2rem;
  .record-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.1rem;
    padding: 0.3rem;
    background: #fff;
    border-left: 0.05rem solid #42b983;
    div {
      line-height: 2.5em;
    }
  }
}

.record-new {
  padding: 10px;
  // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  // font-family: "Segoe UI", "STSong", "Heiti SC", "Noto Sans SC", sans-serif;
  font-family: "Arial", "思源黑体", "等线","Segoe UI", "STSong", "Heiti SC", "Noto Sans SC", sans-serif;
  font-weight: 500;
  font-size: 1em;
}


/* 每条记录的容器 */
.record-item {
  // background-color: #63b773; //#f0f7ff
  background: linear-gradient(135deg, #09bea6 0%, #52be6a 80%) !important;
  border-radius: 20px;
  padding: 10px;
  margin-bottom: 5px;
  font-size: 1em;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 记录头部样式 */
.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  font-size: 1.1em;
  font-weight: 400;
  // padding-bottom: 10px;
  // border-bottom: 1px solid #5CC4AB;
}

.record-date {
  // font-weight: bold;
  color: white;
}

.record-age {
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
}

.record-qr {
  color: #1890ff;
  cursor: pointer;
}

/* 表格样式 */
.record-table {
  width: 93%;
  border-collapse: collapse;
  margin-left: 3%;
}

	
.record-table tr:not(:first-of-type){
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	/* 移除默认边框 */
	  // border-bottom: none;
	  // /* 设置底部内边距，避免文字与渐变线重叠 */
	  // padding-bottom: 5px;
	  // /* 背景渐变：从左到右，从 #09bea6 过渡到 #008080（可自定义颜色） */
	  // background-image: linear-gradient(to right, #50cdb2, #64c786);
	  // /* 限制背景只显示在底部，高度为 1px（模拟边框厚度） */
	  // background-size: 100% 1px;
	  // background-repeat: no-repeat;
	  // background-position: left bottom; /* 定位在底部左侧 */
}

.record-table td {
  padding: 1% 1.1%;
  text-align: center;
  // font-size: 14px;
  color: #333;
  // border: 1px solid #e8e8e8;
}

.record-table .label , .record-table .label-bold {
  color: #f0f7ff;
  // font-weight: bold;
  min-width: 2em;
}

.record-table .label-space {
	max-width:8%;
}

.record-table .label-bold {
	font-weight: 600;
	color: white;
	font-size: 1.1em;
}

/* 详情按钮样式 */
.record-detail {
  text-align: right;
  color: #1890ff;
  cursor: pointer;
  font-size: 14px;
  padding-top: 5px;
}

.tip {
  margin: 0.1rem 0.3rem;
  text-align: left;
  height: 0.6rem;
  line-height: 0.6rem;

  .tip-info {
    color: #999999;
    font-size: 0.26rem;
  }

  .tip-query {
    margin-top: 1rem;
    text-align: center;
  }

  .tip-xieyi {
    position: fixed;
    padding: 0.5rem 0;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    text-align: center;
    font-size: 0.28rem;
  }
}

.ewm {
  margin-top: 0.15rem;
  font-size: 24px;
}

.maskbox,
.maskbox-one {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);

  .mask {
    width: 6rem;
    height: 6rem;
    margin: 30% auto;
    background: #fff;
    border-radius: 10px;
  }

  .maskclose {
    width: 100%;
    height: 0.5rem;

    img {
      width: 0.3rem;
      margin: 0.3rem;
      margin-left: 5.2rem;
    }
  }

  .codetip {
    width: 5rem;
    margin: 0 auto 0.3rem;
    line-height: 1.5em;
    font-size: 0.3rem;
  }
}
.maskbox-one {
  .mask {
      width: 6rem;
      height: 4rem;
      margin: 30% auto;
      background: #fff;
      border-radius: 10px;
    }
}
.mask-btn-div {
  display: flex;
  width: 5rem;
  justify-content: space-between;
  margin: 0.5rem auto;

  .mask-btn {
    width: 2rem;
    height: 0.7rem;
    line-height: 0.7rem;
    border: 1px solid #ccc;
    border-radius: 5px;

    &.ok {
      color: #fff;
      border: 1px solid #5CC4AB;
      background: #5CC4AB;
    }
  }
}

.mask-title {
  margin-bottom: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
}

.mask-content {
  margin-bottom: 0.3rem;
  line-height: 0.5rem;
  text-align: left;
}

.maskbox-one {
  background: rgba(0, 0, 0, 0.8);

  .mask {
    width: 6.9rem;
    height: 5rem;
    padding: 0.3rem 0.5rem;
    box-sizing: border-box;
    margin-top: 30vh;
    border-radius: 10px;
    background: #fff;
  }

  .tip-xieyi-one {
    padding: 2rem 0;
    width: 100%;
    background: transparent;
    text-align: center;
    font-size: 0.32rem;
    color: #fff;
  }

  .xieyi-href {
    font-size: 0.3rem;
    color: #0a6aa1;
    font-weight: bold;
  }
}

.ewmcode {
  width: 150px;
  height: 150px;
  margin: 0 auto;
}

.xieyi-href {
  color: #0a6aa1;
}

.plus {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;

  img {
    width: 0.5rem;
  }
}


@media(max-width: 400px){
	.record-new {
	  padding: 8px;
	  font-family: "Arial", "思源黑体", "等线","Segoe UI", "STSong", "Heiti SC", "Noto Sans SC", sans-serif;
	  font-weight: 500;
	  font-size: 0.8em;
	}
	
	.record-item {
	  border-radius: 20px;
	  padding: 10px;
	  margin-bottom: 5px;
	  font-size: 1.2em;
	  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}
</style>
